import { CircularProgress } from '@material-ui/core';
import { classNames } from 'helper/classNames';
import ReactDOM from 'react-dom';
import { useApiLoaderStore } from 'store/apiLoderStore';

function ApiLoaderContent() {
  const { loaderJobs } = useApiLoaderStore((state) => state);
  document.getElementById('api-loader-container')!.style.zIndex =
    loaderJobs.length > 0 ? '10000000' : '-1';
  return loaderJobs.length > 0 ? (
    <article
      className={classNames({
        show: loaderJobs.length > 0,
        hide: loaderJobs.length === 0,
      })}
    >
      <CircularProgress style={{ color: 'rgb(42, 106, 169)' }} />
    </article>
  ) : (
    <></>
  );
}
export default function ApiLoader() {
  return ReactDOM.createPortal(
    <ApiLoaderContent />,
    document.getElementById('api-loader-container')!
  );
}
